import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Wrench, ArrowRight } from 'lucide-react';

export const CoreToolsCard = ({ index }) => {
  const navigate = useNavigate();

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] }
    }
  };

  const handleCardClick = () => {
    navigate('/Core-Tools-Training');
  };

  return (
    <motion.div
      variants={cardVariants}
      className="relative h-[420px]"
    >
      <motion.div
        className="relative h-full bg-white rounded-2xl shadow-md cursor-pointer overflow-hidden border-2 border-transparent hover:shadow-xl hover:scale-[1.02] transition-all duration-300"
        onClick={handleCardClick}
        whileHover={{ borderColor: 'rgba(71, 85, 105, 0.2)' }}
      >
        <div className="p-6 h-full flex flex-col">
          {/* Icon with gradient background */}
          <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-slate-700 via-gray-800 to-slate-900 flex items-center justify-center mb-4 shadow-lg">
            <Wrench className="h-8 w-8 text-white" />
          </div>

          {/* Badge */}
          <div className="inline-block px-3 py-1 rounded-full text-xs font-semibold text-slate-700 bg-slate-50 self-start mb-3">
            Quality Tools
          </div>

          {/* Title */}
          <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight">
            Core Tools Training
          </h3>

          {/* Gradient underline */}
          <div className="h-1 w-16 bg-gradient-to-r from-slate-700 via-gray-800 to-slate-900 rounded-full mb-4"></div>

          {/* Description */}
          <p className="text-gray-600 text-sm leading-relaxed flex-1 line-clamp-4">
            Master the five essential quality tools - APQP, PPAP, FMEA, MSA & SPC. Industry-recognized training for automotive and manufacturing quality professionals mandated by IATF 16949.
          </p>

          {/* View Details Link */}
          <div className="flex items-center gap-2 text-slate-700 font-semibold text-sm mt-4">
            <span>View Training Details</span>
            <ArrowRight className="h-4 w-4" />
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};
